import { sidebarGetters } from '@/store/modules/sidebar/routines'

export default {
  [sidebarGetters.SIDEBAR_STATUS]: state => state.showSidebar
}
